/**
 * Expected numbers per day for a placement (2026-10-26): two numbers whose
 * meaning follows the channel — website: page views · sessions; newsletter:
 * recipients · opens; social: reach · impressions. Mirrors
 * backend partnerships/stats.py.
 */
export type StatKey = 'page_views' | 'sessions' | 'recipients' | 'opens' | 'reach' | 'impressions';

export const STAT_LABEL: Record<StatKey, string> = {
  page_views: 'Page views',
  sessions: 'Sessions',
  recipients: 'Recipients',
  opens: 'Opens',
  reach: 'Reach',
  impressions: 'Impressions',
};

export const statLabelsFor = (category: string): [StatKey, StatKey] =>
  category === 'Email' ? ['recipients', 'opens']
  : category === 'Social Media' ? ['reach', 'impressions']
  : ['page_views', 'sessions'];

/** "" → null; anything else → a whole number ≥ 0. */
export const toCount = (v: string): number | null => {
  const t = v.replace(/[\s.,]/g, '');
  if (t === '') return null;
  const n = Math.floor(Number(t));
  return Number.isFinite(n) && n >= 0 ? n : null;
};

export const fmtCount = (n: number | null | undefined) => (n == null ? '' : n.toLocaleString('en-GB'));
